import { render, staticRenderFns } from "./ReportLeads.vue?vue&type=template&id=155618af&scoped=true&"
import script from "./ReportLeads.vue?vue&type=script&lang=js&"
export * from "./ReportLeads.vue?vue&type=script&lang=js&"
import style0 from "./ReportLeads.vue?vue&type=style&index=0&id=155618af&lang=scss&scoped=true&"
import style1 from "./ReportLeads.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155618af",
  null
  
)

export default component.exports